import { useEffect } from 'react'

import { Column } from 'app/common/layouts/FiltersDropDownLayout'

import { filterInit } from './filter-init'
import { OperationFilter, PeriodFilter } from './filterItems'

const FILTER_PERIOD = 'complexHistoryPeriod'
const FILTER_OPERATION = 'complexHistoryOperation'

type Props = {
  pending: boolean
  resetStatus: boolean
  defaultOperation: Array<string>
  defaultPeriod: Array<string>
}

export const Filters = ({ pending, resetStatus, defaultOperation, defaultPeriod }: Props) => {
  useEffect(() => {
    return filterInit({
      operation: defaultOperation,
      period: defaultPeriod,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Column>
        <PeriodFilter id={FILTER_PERIOD} pending={pending} resetStatus={resetStatus} />
      </Column>

      <Column>
        <OperationFilter id={FILTER_OPERATION} pending={pending} />
      </Column>
    </>
  )
}
